import React, { useCallback, useEffect, useState } from 'react';
import '../../pages/requestApproval/requestApproval.css';
import "../../components/tableComponent/tableComponent/mastertable.css"
import DetailTable from '../../components/tableComponent/DetailTable';
import axios from 'axios';
import baseConfig from '../../../config/config';
import EditRequest from '../editRequest/editRequest';
import { useNavigate } from "react-router-dom";
import Logs from '../logs/logs';
import Alert from '../../components/alert/alert';
import pencilImage from './../../../assets/pencil.png';
import deleteImage from './../../../assets/delete.png'
import { useDispatch, useSelector } from 'react-redux';
import { updateGPUData } from '../../../redux/reducers/rootReducer';
import { fetchGPUData } from '../../../redux/actions/actions';
function Detail(props) {
    const navigate = useNavigate();
    const [activeTab, setActiveTab] = React.useState(0);
    const [editBlockEnable, setEditBlockEnable] = React.useState(false);
    const [isNewRecord, setIsNewRecord] = React.useState(false);
    const [isError, setIsError] = React.useState(false);
    const [errors, setErrors] = useState({
        CustomerName: "",
        GPUsAllocated: "",
        GPUsRequested: "",
        DC_RegionAllocated: "",
    });
    const [successMessage, setSuccessMessage] = React.useState(false);
    const [updatingRecordMessage, setUpdatingRecordMessage] = React.useState(false);
    const [failedMessage, setFailedMessage] = React.useState(false);
    const GPUData = useSelector(store => store.GPUData.GPUData !== undefined ? store.GPUData.GPUData : []);
    const [openAlert, setOpenAlert] = React.useState(false);
    const [deleteSuccess, setDeleteSuccess] = React.useState(false);
    const [deleting, setDeleting] = React.useState(false)
    const [deleteFailure, setDeleteFailure] = React.useState(false);
    const [notes, setNotes] = useState([])
    const [notesLoader, setNotesLoader] = useState(false)
    const dispatch = useDispatch()
    useEffect(() => {
        if (props.data.length === 0) {
            setIsNewRecord(true)
            setNotesLoader(false)
        } 
    }, [])
    const [selectedArray, setSelectedArray] = React.useState({
        RequestID: props.data?.RequestID || null,
        RequestCode: props.data?.RequestCode || null,
        CustomerName: props.data?.CustomerName || "",
        UAT_ID: props.data?.UAT_ID || "",
        TPID: props.data?.TPID || "",
        RequestDate: props.data?.RequestDate || null,
        RequestStatus: props.data?.RequestStatus || "",
        GPU_Name: props.data?.GPU_Name || "",
        GPUsRequested: props.data?.GPUsRequested || "",
        RegionNeeded: props.data?.RegionNeeded || "",
        RegionFlexibility: props.data?.RegionFlexibility || "",
        DateNeeded: props.data?.DateNeeded || null,
        GPUsAllocated: props.data?.GPUsAllocated || "",
        GPUsOwed: props.data?.GPUsOwed || 0,
        DC_RegionAllocated: props.data?.DC_RegionAllocated || "",
        RI: props.data?.RI || "",
        EarmarkedDate: props.data?.EarmarkedDate || null,
        FullyAllocatedDate: props.data?.FullyAllocatedDate || null,
        Tag: Array.isArray(props.data?.Tag) ? props.data?.Tag.join(',') : props.data?.Tag || [],
        AIGBB: props.data?.AIGBB || "",
        GPUSplitted: props.data?.GPUSplitted || isNewRecord ? null : [],
        LostReason: props.data?.LostReason || "",
        LostToCompetitor: props.data?.LostToCompetitor || "",
        UseCaseCategory: props.data?.UseCaseCategory || "",
        MSX_Opportunity_ID: props.data?.MSX_Opportunity_ID || "",
        MSX_Milestone_ID: props.data?.MSX_Milestone_ID || "",
      });
      
    const tabsData = [
        { label: 'Details', content: <DetailTable isNewRecord={isNewRecord} data={[props?.data]}></DetailTable> },
        { label: 'Logs', content: <Logs /> },
    ];
    useEffect(() =>{
        if(editBlockEnable){
            if (
                props.data.GPUsAllocated &&
                props.data.GPU_Name &&
                props.data.RequestStatus &&
                props.data.DC_RegionAllocated
                ) {
                dispatch(
                    updateGPUData({
                    object: props.data,
                    transaction: "add",
                    })
                );
                }
        }
    }, [editBlockEnable])
    const update = async () => {  
        setUpdatingRecordMessage("Updating Request...");
        let postData = Object.fromEntries(
            Object.entries(selectedArray).map(([key, value]) => [key, value])
        );
        if (Array.isArray(postData.GPUSplitted) && postData.GPUSplitted.length === 0) {
            postData.GPUSplitted = null;
        }
        if (!Array.isArray(postData.Tag) && postData.Tag !== "") {
            postData.Tag = postData.Tag.split(",")
        }
        postData.SplitFrom = 0;
        try {
            let csrfToken=localStorage.getItem("csrfToken")
            const apiEndpoint = '/request/edit';
            const response = await axios.post(
                baseConfig.apiBaseUrl + apiEndpoint,
                postData,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        "serviceid": sessionStorage.getItem("userToken"),
                        "X-CSRF-Token": csrfToken
                    },
                    withCredentials: true,
                }
            );
            if (response.status === 200) {
                setUpdatingRecordMessage("");
                setSuccessMessage("Request Updated Successfully");
                setTimeout(() => {
                    setSuccessMessage("");
                    window.location.reload();
                }, 2000);
            }else{
                setFailedMessage("Failed to Update Request")
                setUpdatingRecordMessage("");
                setTimeout(() => {
                    setFailedMessage("");
                }, 2000);
            }
        } catch (error) {
            console.error('API Error:', error);
            setFailedMessage("Failed to Update Request")
            setTimeout(() => {
                setFailedMessage("");
            }, 2000);
            setUpdatingRecordMessage("");
            if (error.response?.status === 401) {
                navigate("/errorPage");
            }
        }
    };
    const submitNewRecord = async () => {
        let postData = Object.fromEntries(
            Object.entries(selectedArray).map(([key, value]) => [key, value])
        );
        if (postData.hasOwnProperty("GPUsOwned")) {
            postData["GPUsOwed"] = postData["GPUsOwned"];
            delete postData["GPUsOwned"];
        }
        postData["SplitFrom"] = 0;
        if (selectedArray['CustomerName']) {
            try {
                setUpdatingRecordMessage("Adding Request...");
                let csrfToken=localStorage.getItem("csrfToken")
                const response = await axios.post(
                    baseConfig.apiBaseUrl + '/request/add',
                    postData,
                    {
                        headers: {
                            'Content-Type': 'application/json',
                            "serviceid": sessionStorage.getItem("userToken"),
                            "X-CSRF-Token": csrfToken
                        },
                        withCredentials: true,
                    }
                );
                if (response.status === 200) {
                    setUpdatingRecordMessage("");
                    setSuccessMessage("Request Added Successfully");
                    setTimeout(() => {
                        setSuccessMessage("");
                        window.location.reload();
                    }, 2000);
                }else{
                    setUpdatingRecordMessage("");
                    setFailedMessage("Failed to Add Request")
                    setTimeout(() => {
                        setFailedMessage("");
                    }, 2000);
                }

            } catch (error) {
                console.error('API Error:', error);
                setUpdatingRecordMessage("");
                setFailedMessage("Failed to Add Request")
                setTimeout(() => {
                    setFailedMessage("");
                }, 2000);
                if (error.response?.status === 401) {
                    navigate("/errorPage");
                }
            }
        } 
    };

    const deleteRecord = async () => {
        setDeleting(true);
        let postData = {
            "RequestID": selectedArray.RequestID
        };

        try {

            const apiEndpoint = '/request/delete';
            const response = await axios.post(
                baseConfig.apiBaseUrl + apiEndpoint,
                postData,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        "serviceid": sessionStorage.getItem("userToken"),
                        "X-CSRF-Token": localStorage.getItem("csrfToken")
                    },
                    withCredentials: true,
                }
            );
            if (response.status === 200) {
                setDeleting(false);
                setDeleteSuccess(true);
                setTimeout(() => {
                    setDeleteSuccess(false);
                    window.location.reload();
                }, 2000);
            }

        } catch (error) {
            console.error('API Error:', error);
            setDeleting(false);
            setDeleteFailure(true);
            setTimeout(() => {
                setDeleteFailure(false);
            }, 3000);
            if (error.response?.status === 401) {
                navigate("/errorPage");
            }
        }
    };
    const validateGPUCount = (value) => {
        if (value) {
            return( parseInt(value) % 8 === 0);
          }
    }
    const validate_GPU_Granted = (updatedJsonDataArray) => {
        let value = parseInt(updatedJsonDataArray.GPUsAllocated)
        if (value) {
          if (["Partially Allocated", "Fully Allocated"].includes(updatedJsonDataArray.RequestStatus)) {
            let capacity = [];
            if (updatedJsonDataArray.GPU_Name) {
              capacity = GPUData[updatedJsonDataArray.GPU_Name].filter(
                (item) => item.Region === updatedJsonDataArray.DC_RegionAllocated
              );
            }
            const availableGPUs = capacity[0]?.GPUsAvailable || 0;
    
            if (value > availableGPUs) {

              return "GPU Granted cannot be greater than Available GPU";
            }
          }
          if (value !== "" && value!==0 && value % 8 !== 0) {
            return "GPU Granted must be a multiple of 8";
          }
        }
        return ""
      }
    const validateForm = (updatedJsonDataArray) => {  
        if (updatedJsonDataArray.GPUsRequested && !validateGPUCount(updatedJsonDataArray.GPUsRequested)) {
            setErrors(prevErrors => ({
                ...prevErrors,
                GPUsRequested: "GPU Requested should be a multiple of 8",
            }));
        }else{
            setErrors(prevErrors => ({
                ...prevErrors,
                GPUsRequested: "",
            }));
        }
        if(updatedJsonDataArray.GPUsAllocated ){
            const error = validate_GPU_Granted(updatedJsonDataArray);
            setErrors((prevErrors) => ({
              ...prevErrors,
              GPUsAllocated: error,
            }));
        }
        if (updatedJsonDataArray.GPU_Name !== "" && errors.DC_RegionAllocated?.length > 0){
            setErrors(prevErrors => ({
                ...prevErrors,
                DC_RegionAllocated: "",
            }));
        }
    };
    useEffect(() => {
        if (Object.values(errors).every((val) => val === "")) {
            setIsError(false);
        } else {
            setIsError(true);
        }
    }, [errors]); 
    const handleInputChange = (updatedJsonDataArray) => {
        if (updatedJsonDataArray['CustomerName'] === "" || !updatedJsonDataArray['CustomerName']) {
            setErrors(prevErrors => ({
                ...prevErrors,
                CustomerName: "Customer Name cannot be empty",
              }));
        }else{
            setErrors(prevErrors => ({
                ...prevErrors,
                CustomerName: "",
              }));
        }
        setSelectedArray(updatedJsonDataArray)
        validateForm(updatedJsonDataArray)
    };
    const handleEditClick = () => {
        setEditBlockEnable(!editBlockEnable);
    }

    const handleTabClick = (index) => {
        setActiveTab(index);
    };


    const handleEscapeKeyPress = useCallback((event) => {
        if (event.key === 'Escape') {
            props.closeConfirmationModal(selectedArray)
        }
    }, []);

    useEffect(() => {
        document.addEventListener('keydown', handleEscapeKeyPress);

        return () => {
            document.removeEventListener('keydown', handleEscapeKeyPress);
        };
    }, [handleEscapeKeyPress]);

    const closeEdit = () => {
        setEditBlockEnable(false);  
        dispatch(fetchGPUData())
    }
    return (
        <>
            <div className="modal-container">

                <div style={{ maxHeight: '80vh' }}>
                    <div className="title" style={{ display: 'flex', width: '100%', alignItems: 'center' }}>
                        {editBlockEnable ? <b>Edit</b> : isNewRecord ? <b>New Request</b> : <b>Detailed View</b>}
                        {!editBlockEnable && !isNewRecord &&
                            <button style={{ padding: '15px', height: '35px', backgroundColor: '#4b81ff', color: 'white', border: 'none', borderRadius: '5px', marginLeft: 'auto', cursor: 'pointer', display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }} onClick={handleEditClick}>
                                <img src={pencilImage} style={{ width: '13px', marginRight: '8px' }}></img>
                                Edit
                            </button>
                        }
                        {!editBlockEnable && !isNewRecord &&
                            <button style={{ padding: '15px', height: '35px', backgroundColor: '#D13438', color: 'white', border: 'none', borderRadius: '5px', marginLeft: '20px', cursor: 'pointer', display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }} onClick={() => { setOpenAlert(true) }} disabled={deleting}>
                                <img src={deleteImage} style={{ width: '13px', marginRight: '8px' }}></img>
                                Delete
                            </button>
                        }
                        <i className="fa fa-times close-icon"
                            style={{ marginLeft: '20px', marginRight: '10px' }}
                            onClick={editBlockEnable ? () => closeEdit() : () => props.closeConfirmationModal(selectedArray)}
                        ></i>
                    </div>

                    <hr className="divider" />

                    {!editBlockEnable && !isNewRecord &&
                        <ul className="tab-list" style={{ padding: '0px', marginBottom: '20px' }}>
                            {tabsData.map((tab, index) => (
                                <li
                                    key={index}
                                    className={activeTab === index ? 'active-tab' : ''}
                                    onClick={() => handleTabClick(index)}
                                >
                                    {tab.label}
                                </li>
                            ))}
                        </ul>
                    }

                    {(editBlockEnable || isNewRecord) &&
                        <div style={{ overflow: 'auto', maxHeight: '60vh' }}>
                            <EditRequest
                                setErrors={setErrors}
                                setIsError={setIsError}
                                errors={errors}
                                editBlockEnable={editBlockEnable}
                                setEditBlockEnable={setEditBlockEnable}
                                data={props?.data}
                                handletableInputChange={props.handletableInputChange}
                                handleInputChange={handleInputChange}
                                isNewRecord={isNewRecord}
                                notes={notes}
                                notesLoader={notesLoader}
                            ></EditRequest>
                        </div>
                    }

                    {!editBlockEnable && !isNewRecord &&
                        <div className="tab-content">
                            {activeTab === 0 ?
                                <DetailTable data={[props?.data]} notes={notes} notesLoader={notesLoader}
                                ></DetailTable>
                                :
                                <Logs data={props?.data}></Logs>
                            }
                        </div>
                    }


                    <hr className="divider" />

                    <div className="buttons-container">
                        {editBlockEnable &&
                            <div className="button-container" style={{ marginBottom: '20px', marginRight: '10px', opacity: (isError || errors.length > 0)  ? .5 : 1 }}>
                                <button disabled={isError  || updatingRecordMessage} onClick={update}>Update</button>
                            </div>
                        }
                        {isNewRecord &&
                            <div className="button-container" style={{ marginBottom: '20px', marginRight: '10px', opacity: (isError || errors.length > 0)  ? .5 : 1 }}>
                                <button disabled={isError  || updatingRecordMessage} onClick={submitNewRecord}>Add </button>
                            </div>
                        }
                        <button
                            className="button button-go-back"
                            onClick={editBlockEnable ? () => closeEdit() : () => props.closeConfirmationModal(selectedArray)}
                            style={{ marginBottom: '20px' }}
                        >
                            Cancel
                        </button>


                    </div>
                </div>
            </div>


            {openAlert &&
                <>
                    <div className="modal-backdrop" style={{ zIndex: '1000' }}></div>
                    <Alert message={'Are you sure you want to delete this request?'} SubmitbuttonText={'Delete'} onclickSubmit={deleteRecord} deleteSuccess={deleteSuccess} deleteFailure={deleteFailure} deleting={deleting} onClickCancel={() => { setOpenAlert(false) }}></Alert>
                </>
            }
            {updatingRecordMessage && <div className="alert" style={{ backgroundColor: '#aaaa09' }}>
                {updatingRecordMessage}
            </div>}
            {successMessage && <div className="alert" style={{ backgroundColor: '#4CAF50' }}>
                {successMessage}
            </div>}
            {failedMessage && <div className="alert">
                {failedMessage}
            </div>}
            {deleting && <div className="alert" style={{ backgroundColor: '#aaaa09' }}>
                Deleting Request
            </div>}
            {deleteSuccess && <div className="alert" style={{ backgroundColor: '#4CAF50' }}>
            Request Deleted Successfully
            </div>}
            {deleteFailure && <div className="alert">
                Failed To Delete Request. Try again.
            </div>}
        </>
    );
}

export default Detail;